<template>
  <router-link
    id="cartLink"
    :to="{ name: 'cart' }"
    tag="a"
    class="flex intro-x py-2 px-6 bg-theme-11 hover:bg-theme-35 hover:text-white"
  >
    <ShoppingCartIcon class="m-auto shopping-cart" />
    <p v-if="getCountQuotations">{{ getCountQuotations }}</p>
  </router-link>
</template>
<script>
import { CART_COUNT_LOCAL_STORAGE } from '@/constants'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('cart', {
      getCountQuotations: 'getCountQuotations'
    })
  },
  methods: {
    async getCurrentCart() {
      this.$store.commit('main/setShowSpinner', true)
      const response = await this.axios.get('sales-operator/cart', {
        headers: {
          Authorization: `Bearer ${this.$store.state.auth.token}`,
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json'
        }
      })
      this.$store.commit(
        'cart/setCountQuotations',
        response?.data?.multi_quotation?.quotations?.length || 0
      )

      this.$store.commit(
        'cart/setCartData',
        response?.data?.multi_quotation || []
      )

      this.$store.commit(
        'cart/setProductsInterests',
        response?.data?.product_interests || []
      )

      this.$store.commit('main/setShowSpinner', false)
    }
  },
  beforeMount() {
    const cartCountData = localStorage.getItem(CART_COUNT_LOCAL_STORAGE)
    if (cartCountData !== null) {
      this.$store.commit('cart/setCountQuotations', cartCountData)
    } else {
      this.getCurrentCart()
    }
  }
}
</script>

<style scoped>
#cartLink.router-link-active,
#cartLink.router-link-exact-active {
  background-color: rgba(255, 222, 137, var(--tw-bg-opacity)) !important;
  color: #fff;
}
</style>
